// extracted by mini-css-extract-plugin
export default {"container":"Products_container__tPtyu","products":"Products_products__y9e3y","menu":"Products_menu__gwFN6","list":"Products_list__0VqSL","product":"Products_product__Wb-Ox"};